import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2026 Get Set Moove. All rights reserved.</p>
    </footer>
  );
};

 export default Footer;